export const getProgressData = (completedStepsStr = "") => {
  const [done, total] = completedStepsStr.split("/").map(Number)

  return { done, total }
}

export const isStepCompleted = (str = "") => {
  const { done, total } = getProgressData(str)
  return done >= total
}

export const isAllBusinessCompleted = (accounts) =>
  accounts.every((acc) => isStepCompleted(acc.completed_steps))

export const getProgressPercent = (completedStepsStr, isAdditionalStep) => {
  if (!completedStepsStr) return 0

  const { done, total } = getProgressData(completedStepsStr)

  if (!total || isNaN(done) || isNaN(total)) return 0
  const maxTotal = isAdditionalStep ? total + 1 : total

  return Math.round((done / maxTotal) * 100)
}
